import Page from 'components/layout/Page';
import { FaqProps } from 'components/marketingSite/shared/FaqsItem';
import MarkdownComponent from 'components/shared/MarkdownComponent';
import { useI18n } from 'hooks/useI18n';
import Faqs from '../shared/Faqs';
import TEFeatures from './sections/features/Features';
import TalentEngineFooter from './sections/footer/TalentEngineFooter';
import TEHero from './sections/hero/Hero';
import TENav from './sections/nav/Nav';
import { TESteps } from './sections/steps/Steps';
import { StyledWrapper } from './TalentEngineComponent.styled';
import { CustomersItem, FaqItem } from './TalentEngineComponent.types';

type ContentProps = {
  customers: CustomersItem[];
  faqs: FaqItem[];
};

const TalentEngineComponent: React.FC<ContentProps> = ({ faqs }) => {
  const { t } = useI18n('talent-engine-landing-v3');

  const faqsArray: FaqProps[] =
    faqs
      ?.sort((a, b) => a.attributes.order - b.attributes.order)
      .map((faq) => ({
        question: faq.attributes.question,
        answer: <MarkdownComponent content={faq.attributes.answer} />,
        renderComponent: true
      })) || [];

  return (
    <Page pageVariant="light">
      <StyledWrapper>
        <TENav />
        <TEHero />
        <TESteps />
        <TEFeatures />
        <Faqs faqs={faqsArray} title={t('talent-engine-landing.faqs.title')} />
        <TalentEngineFooter />
      </StyledWrapper>
    </Page>
  );
};

export default TalentEngineComponent;
